import { ATSPrincipalAppCandidatesListTestIds } from 'data-testids/ATS';
import { useState } from 'react';
import { CandidatesListOrdering } from '../types/candidatesListTypes';
import { CandidatesHeader } from './components/CandidatesHeader';
import { CandidatesList } from './components/CandidatesList';
import { sortOptions } from './components/data';
import { Container, PageContainer } from './styles';

export const PrincipalCandidatesList = () => {
  const [ordering, setOrdering] = useState<CandidatesListOrdering>(sortOptions[0].ordering);

  return (
    <PageContainer data-testid={ATSPrincipalAppCandidatesListTestIds.CANDIDATES_LIST}>
      <Container>
        <CandidatesHeader value={ordering} onChange={setOrdering} />
        <CandidatesList ordering={ordering} key={ordering} />
      </Container>
    </PageContainer>
  );
};
